import { IconProps } from "../../types/genereal";
import { IconWrapper } from "components/ui/IconWrapper";

export const TwoPersonIcon = ({
  width = "20",
  height = "20",
  color = "#FE8836",
  secondColor = "#1C3C6C",
  rotate,
}: IconProps) => {
  return (
    <IconWrapper width={width} height={height} rotate={rotate}>
      <svg
        width={width}
        height={height}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M13.75 9.16602C15.1333 9.16602 16.2417 8.04935 16.2417 6.66602C16.2417 5.28268 15.1333 4.16602 13.75 4.16602C12.3667 4.16602 11.25 5.28268 11.25 6.66602C11.25 8.04935 12.3667 9.16602 13.75 9.16602ZM13.75 10.8327C13.5083 10.8327 13.2333 10.8493 12.9417 10.8743C13.9083 11.5743 14.5833 12.516 14.5833 13.7493V15.8327H19.5833V13.7493C19.5833 11.8077 15.6917 10.8327 13.75 10.8327Z"
          fill={secondColor}
        />
        <path
          d="M7.08333 10.8327C5.14167 10.8327 1.25 11.8077 1.25 13.7493V15.8327H12.9167V13.7493C12.9167 11.8077 9.025 10.8327 7.08333 10.8327Z"
          fill={color}
        />
        <path
          d="M7.08333 9.16602C8.46667 9.16602 9.575 8.04935 9.575 6.66602C9.575 5.28268 8.46667 4.16602 7.08333 4.16602C5.7 4.16602 4.58333 5.28268 4.58333 6.66602C4.58333 8.04935 5.7 9.16602 7.08333 9.16602Z"
          fill={color}
        />
      </svg>
    </IconWrapper>
  );
};
